import { render } from "./BookingAppointmentPage.vue?vue&type=template&id=1bd75201"
import script from "./BookingAppointmentPage.vue?vue&type=script&lang=js"
export * from "./BookingAppointmentPage.vue?vue&type=script&lang=js"

import "./BookingAppointmentPage.vue?vue&type=style&index=0&id=1bd75201&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__